import { generateJobSchema } from './helpers';
import {
  GenerateStructuredDataType,
  JobStucturedDataProps,
  StructuredDataResponse,
} from './interfaces';

function createStructuredData(
  type: 'JobPosting',
  props: JobStucturedDataProps
): StructuredDataResponse;

function createStructuredData(
  type: GenerateStructuredDataType,
  props: JobStucturedDataProps
): StructuredDataResponse {
  if (type === 'JobPosting') {
    return generateJobSchema(props as JobStucturedDataProps);
  }
  return {};
}

export default createStructuredData;
